import React from 'react';
import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { Link } from 'react-router-dom';

const drawerWidth = 240;

export default function SideBar() {
  return (
    <Drawer
      variant="permanent"
      sx={{
          width: drawerWidth,
          flexShrink: 0,
          ['& .MuiDrawer-paper']: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            <ListItem disablePadding component={Link} to="/search"
              sx={{
                color: 'inherit',          // Inherit text color from theme
                textDecoration: 'none',     // Removes underline, just in case
              }}>
              <ListItemButton>
                <ListItemIcon>
                  <RestaurantIcon />
                </ListItemIcon>
                <ListItemText>
                  My Recipes
                </ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding component={Link} to="/recipe/new"
              sx={{
                color: 'inherit',          // Inherit text color from theme
                textDecoration: 'none',     // Removes underline, just in case
              }}>
              <ListItemButton>
                <ListItemIcon>
                  <NoteAddIcon />
                </ListItemIcon>
                <ListItemText>
                  Add Recipe
                </ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding component={Link} to="/recipe/import"
              sx={{
                color: 'inherit',          // Inherit text color from theme
                textDecoration: 'none',     // Removes underline, just in case
              }}>
              <ListItemButton>
                <ListItemIcon>
                  <CameraAltIcon />
                </ListItemIcon>
                <ListItemText>
                  Import
                </ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding component={Link} to="/search"
              sx={{
                color: 'inherit',          // Inherit text color from theme
                textDecoration: 'none',     // Removes underline, just in case
              }}>
              <ListItemButton>
                <ListItemIcon>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText primary="Search" />
              </ListItemButton>
            </ListItem>
          </List>
          <Divider />
        </Box>
        <Box sx={{ marginTop: 'auto' }}>
            <List>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText>
                    Settings
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
      </Drawer>
  )
}
